/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownLeftIcon20Regular = forwardRef('ArrowADownLeftIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5.81 15.25h7.69a.75.75 0 0 1 0 1.5h-8a2.25 2.25 0 0 1-2.25-2.25v-8a.75.75 0 0 1 1.5 0v7.69L15.47 3.47a.75.75 0 1 1 1.06 1.06L5.81 15.25Z" })));
});
